import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import SelectAllClass from "../ChildComponent/SelectAllClass";

const UdiseForm = () => {
  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [fileURL, setFileURL] = useState("");
  const [mPrintableSamples, setPrintableSamples] = useState([]);

  const [selectedClassPosition, setSelectedClassPosition] = useState(-1);

  const [fileName, setFileName] = useState("");
  const [fileDirectory, setFileDirectory] = useState("");
  const [selectedSampleId, setSelectedSampleId] = useState("");

  const [classSectionName, setClassSectionName] = useState("");

  const classIdRef = useRef("");
  const sectionIdRef = useRef("");
  const sessionIdRef = useRef("");

  const { document_type } = useParams();
  const [height, setHeight] = useState("300px");
  const iframeRef = useRef(null);

  useEffect(() => {
    //window.scrollTo(0, 0);
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const callBackClassSelect = (
    class_id,
    section_id,
    session_id,
    selected_position,
    class_name,
    section_name
  ) => {
    classIdRef.current = class_id;
    sectionIdRef.current = section_id;
    sessionIdRef.current = session_id;
    setSelectedClassPosition(selected_position);

    const classSection =
      section_id === "No" ? class_name : `${class_name}:${section_name}`;
    setClassSectionName(classSection);

    if (mPrintableSamples.length === 0) {
      fetchPrintableSamples();
    } else {
      setFileUrl();
    }
  };

  const fetchPrintableSamples = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          document_type: document_type,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const firstSample = response.data[0];
          setPrintableSamples(response.data);
          setFileName(firstSample.file_name);
          setFileDirectory(firstSample.file_directory);
          setSelectedSampleId(firstSample.sample_id);
          setFileUrl(
            firstSample.file_name,
            firstSample.file_directory,
            firstSample.sample_id
          );
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching samples", error);
      });
  };

  const setFileUrl = (
    customFileName = fileName,
    customDirectory = fileDirectory,
    customSampleId = selectedSampleId
  ) => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const url =
      process.env.REACT_APP_SERVER_NAME +
      customDirectory +
      customFileName +
      `?&class_id=${classIdRef.current}&section_id=${sectionIdRef.current}` +
      `&class_section_name=${classSectionName}&session_id=${sessionIdRef.current}` +
      `&sample_id=${customSampleId}&system_code=${process.env.REACT_APP_SYSTEM_CODE}` +
      `&school_code=${SCHOOL_CODE}`;

    setFileURL(url);
    setShowPreview(true);
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <div className="content">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#">Udise S02 Form</a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="animated fadeInUpn bg_page_white_rounded box_shadow"
        style={{ "--mMargin": "50px" }}
      >
        <SelectAllClass
          action={callBackClassSelect}
          selected_position={selectedClassPosition}
        />

        <div className="row" style={{ margin: "0px 10px 0px 10px" }}>
          <h5 className="">Preview</h5>
        </div>

        <div className="row" style={{ margin: "0px 10px 0px 10px" }}>
          {showPreview && <MyLoader />}
          <Iframe
            ref={iframeRef}
            src={fileURL}
            width="100%"
            height={height}
            style={{ border: "none", overflow: "hidden" }}
            id="iFrame1"
            scrolling="no"
            onLoad={() => setShowPreview(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default UdiseForm;
